import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fileUrl = (url) => {
  if (!url) return url;
  if (url.startsWith("http")) return url;
  const sep = url.includes("?") ? "&" : "?";
  return `${BACKEND_URL}${url}${sep}v=2`;
};

export function trackListingView(id) {
  if (!id) return;
  try {
    const key = "viewed_listings";
    const seen = JSON.parse(sessionStorage.getItem(key) || "[]");
    if (seen.includes(id)) return;
    seen.push(id);
    sessionStorage.setItem(key, JSON.stringify(seen));
  } catch { /* ignore */ }
  api.post(`/listings/${id}/view`).catch(() => {});
}

export function formatApiError(detail) {
  if (detail == null) return "Xəta baş verdi. Yenidən cəhd edin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
